<template>
  <section class="groups">
    <form method="post" @submit.prevent="onSend">
      <b-field horizontal :label="$t('attributes.name')">
        <b-input v-model="product_name" disabled expanded></b-input>
      </b-field>

      <b-field horizontal :label="$t('attributes.product_code')">
        <b-input v-model="product_code" disabled expanded></b-input>
      </b-field>

      <hr />

      <b-field horizontal :label="$t('attributes.related_groups')">
        <div class="columns is-multiline is-mobile">
          <b-checkbox
            v-model="selectedAllGroups"
            class="column is-4 is-marginless"
            @input="onSelectedAllGroups"
          >
            {{ $t('attributes.select_all') }}
          </b-checkbox>
          <b-checkbox
            v-model="showExpiredGroups"
            class="column is-5 is-marginless"
            @input="onShowExpiredGroups"
            style="color:brown;"
          >
            {{ $t('attributes.display_expired') }}
          </b-checkbox>
          <b-checkbox
            v-for="group in groups"
            v-model="form.groups"
            :key="group.code"
            :native-value="group.code"
            class="column is-4 is-marginless is-selectable"
            @input="onSelectedGroup"
          >
            <span>{{ group.code }}</span>
            <span
              v-if="!group.shelve_on"
              class="ml-0.5 has-text-danger has-text-weight-bold"
            >
              (下架)
            </span>
          </b-checkbox>
          <b-collapse
            :open="false"
            position="is-bottom"
            aria-id="showMore"
            v-if="moreGroups.length > 0"
            style="width: 100%;"
          >
            <template #trigger="props">
              <a
                aria-controls="showMore"
                :aria-expanded="props.open"
                style="font-size: 18px;"
              >
                <b-icon :icon="!props.open ? 'menu-down' : 'menu-up'"></b-icon>
                {{ !props.open ? 'more' : 'hide' }}
              </a>
            </template>
            <b-checkbox
              v-for="group in moreGroups"
              v-model="form.groups"
              :key="group.code"
              :native-value="group.code"
              class="column is-4 is-marginless is-selectable"
              @input="onSelectedGroup"
            >
              <span>{{ group.code }}</span>
              <span
                v-if="!group.shelve_on"
                class="ml-0.5 has-text-danger has-text-weight-bold"
              >
                (下架)
              </span>
            </b-checkbox>
          </b-collapse>
        </div>
      </b-field>

      <hr />

      <b-field horizontal :label="$t('attributes.update_items')">
        <div class="columns is-multiline is-mobile">
          <b-checkbox
            v-model="selectedAllFields"
            class="column is-12 is-marginless"
            @input="onSelectedAllFields"
          >
            {{ $t('attributes.select_all') }}
          </b-checkbox>
          <b-checkbox
            v-for="field in fields"
            v-model="form.fields"
            :key="field.key"
            :native-value="field.key"
            class="column is-3 is-marginless"
            @input="onSelectedField"
          >
            <p class="has-text-weight-medium" :style="{ color: field.color }">
              {{ field.name }}
            </p>
          </b-checkbox>
        </div>
      </b-field>
      <b-field horizontal>
        <b-button
          :loading="sending"
          type="is-primary"
          native-type="submit"
          style="width: 100%; margin-top: 20px;"
        >
          {{ $t('attributes.update_data') }}
        </b-button>
      </b-field>
    </form>

    <b-loading :active.sync="loading" :is-full-page="false"></b-loading>
  </section>
</template>

<script>
import { PRODUCTS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'OverrideForm',

  props: {
    product: {
      required: true,
      type: Object
    }
  },
  data() {
    const shelveName = `${this.product.shelve_on ? '複寫為上架' : '複寫為下架'}`

    return {
      loading: false,
      sending: false,
      costChecked: false,
      differentPrice: false,

      product_code: this.product.code,
      product_name: this.product.name,

      selectedAllFields: false,
      showExpiredGroups: false,
      fields: [
        { key: 'name', name: '團名', color: 'black' },
        { key: 'alias', name: '團別大標', color: 'black' },
        {
          key: 'operator_remark',
          name: '團控表備註',
          color: 'black'
        },
        { key: 'airline', name: '航空公司', color: 'black' },
        { key: 'shelve_on', name: shelveName, color: 'black' },
        { key: 'situation', name: '銷售狀態', color: 'black' },
        { key: 'attributes', name: '屬性', color: 'black' },
        { key: 'doc_url', name: 'PDF檔連結', color: 'black' },

        { key: 'cost', name: '價格(進階)維護', color: 'darkgreen' },
        { key: 'price_remark', name: '團費說明', color: 'darkgreen' },

        { key: 'product_cover', name: '個團圖片', color: 'brown' },
        { key: 'route_picture', name: '路線圖片', color: 'brown' },
        { key: 'banner_picture', name: '內頁大圖', color: 'brown' },

        { key: 'transfer', name: '航班交通', color: 'blue' },
        { key: 'voyage', name: '航程管理', color: 'blue' },
        { key: 'traffic', name: '交通說明', color: 'blue' },
        { key: 'feature', name: '行程特色', color: 'blue' },
        { key: 'remark', name: '促銷訊息', color: 'blue' },
        { key: 'feature_simple', name: '特色', color: 'blue' },
        { key: 'blogs', name: '行程相簿', color: 'blue' },
        { key: 'schedule', name: '每日行程', color: 'blue' },
        { key: 'food', name: '餐食住宿', color: 'blue' },
        { key: 'notes', name: '優惠說明', color: 'blue' },

        { key: 'catalogs', name: '分類', color: 'black' },
        { key: 'national_flag', name: '國旗', color: 'black' },
        { key: 'weather', name: '城市氣象', color: 'black' },
        { key: 'blocks', name: '內頁區塊設定', color: 'black' }
      ],
      selectedAllGroups: false,
      groups: [],
      moreGroups: [],
      allGroups: [],
      form: {
        fields: [],
        groups: []
      }
    }
  },
  watch: {
    product(product) {
      this.product_code = product.code
      this.product_name = product.name

      this.selectedAllFields = false
      this.form.fields = []

      this.selectedAllGroups = false
      this.groups = []
      this.moreGroups = []
      this.form.groups = []

      const shelveName = `${product.shelve_on ? '複寫為上架' : '複寫為下架'}`
      this.fields = this.fields.map(f => {
        if (f.key === 'shelve_on') {
          return {
            ...f,
            name: shelveName
          }
        } else {
          return f
        }
      })

      this.loadGroups()
    }
  },
  mounted() {
    this.loadGroups()
  },
  methods: {
    async onPriceDifferentCheck() {
      await this.priceDifferentCheck()
      if (this.differentPrice) {
        this.$buefy.dialog.alert({
          type: 'is-danger is-light',
          title: '旅行團價格不一致',
          hasIcon: true,
          icon: 'alert',
          ariaRole: 'alertdialog',
          ariaModal: true,
          message:
            '勾選之旅行團【價格】不一致<br>請<span style="color: red;">取消「價格(進階)維護」</span>再做複寫旅行團',
          confirmText: '確定'
        })
      }
    },
    async priceDifferentCheck() {
      if (this.form.groups.length > 1) {
        const codes = this.form.groups.join(',')
        const api = `${PRODUCTS_API}/${codes}/related-groups/price-different-check`
        try {
          this.loading = true
          const res = await this.axios.get(api)
          this.differentPrice = res.data.data
        } catch (e) {
          notifyService.fetch_error('related_groups', e)
        } finally {
          this.loading = false
        }
      }
    },
    async loadGroups() {
      const api = `${PRODUCTS_API}/${
        this.product_code
      }/related-groups?show_expired=${
        this.showExpiredGroups ? 'true' : 'false'
      }`

      try {
        this.loading = true
        const res = await this.axios.get(api)
        this.allGroups = res.data.data
        if (this.allGroups.length > 9) {
          this.groups = this.allGroups.slice(0, 9)
          this.moreGroups = this.allGroups.slice(9, this.allGroups.length)
        } else {
          this.groups = this.allGroups
          this.moreGroups = []
        }
        this.form.groups = []
      } catch (e) {
        this.groups = []
        this.moreGroups = []
        this.form.groups = []

        notifyService.fetch_error('related_groups', e)
      } finally {
        this.loading = false
      }
    },
    onSelectedAllFields(selected) {
      if (selected) {
        this.form.fields = this.fields.map(g => g.key)
      } else {
        this.form.fields = []
      }

      if (
        this.form.fields.join(',').indexOf('cost') === -1 &&
        this.costChecked
      ) {
        this.costChecked = false
        this.differentPrice = false
      } else if (this.form.fields.join(',').indexOf('cost') !== -1) {
        this.onPriceDifferentCheck()
        this.costChecked = true
      }
    },
    onSelectedField() {
      this.selectedAllFields = this.form.fields.length === this.fields.length
      if (
        this.form.fields.join(',').indexOf('cost') === -1 &&
        this.costChecked
      ) {
        this.costChecked = false
        this.differentPrice = false
      } else if (
        this.form.fields.join(',').indexOf('cost') !== -1 &&
        !this.costChecked
      ) {
        this.onPriceDifferentCheck()
        this.costChecked = true
      }
    },
    onSelectedAllGroups(selected) {
      if (selected) {
        this.form.groups = this.allGroups.map(g => g.code)
      } else {
        this.form.groups = []
      }
    },
    onSelectedGroup() {
      this.selectedAllGroups = this.form.groups.length === this.groups.length
    },
    onShowExpiredGroups() {
      this.loadGroups()
    },
    async onSend() {
      if (this.form.fields.length === 0) {
        return notifyService.error('至少需選擇一個複寫欄位')
      }

      if (this.form.groups.length === 0) {
        return notifyService.error('至少需選擇一個旅行團')
      }

      if (this.costChecked) {
        await this.priceDifferentCheck()
        if (this.differentPrice) {
          this.$buefy.dialog.alert({
            type: 'is-danger is-light',
            title: '更新失敗',
            hasIcon: true,
            icon: 'alert',
            ariaRole: 'alertdialog',
            ariaModal: true,
            message:
              '勾選之旅行團【價格】不一致<br>請<span style="color: red;">取消「價格(進階)維護」</span>再做複寫旅行團',
            confirmText: '確定'
          })
          return notifyService.error('更新失敗')
        }
      }
      const api = `${PRODUCTS_API}/${this.product.code}/related-groups`
      const data = {
        fields: this.form.fields.join(','),
        groups: this.form.groups.join(',')
      }

      try {
        this.loading = true
        this.sending = true
        await this.axios.put(api, data)
        if (this.form.fields.join(',').indexOf('shelve_on') !== -1) {
          await this.loadGroups()
        }
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.loading = false
        this.sending = false
      }
    }
  }
}
</script>
